document.addEventListener("DOMContentLoaded", () => {
    let pagination = document.querySelectorAll('.search-form');
    for (let i = 0; i < pagination.length; i++) {
        pagination[i].addEventListener("click", function (e) {
            e.preventDefault();
        });
    }
});